import { render, staticRenderFns } from "./videopicker.vue?vue&type=template&id=676887c6&scoped=true&"
import script from "./videopicker.vue?vue&type=script&lang=js&"
export * from "./videopicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676887c6",
  null
  
)

export default component.exports